import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { steps } from "../constants";
import Step0Service from "./steps/Step0Service";
import Step1Profile from "./steps/Step1Profile";
import Step2Contacts from "./steps/Step2Contacts";
import Step3Privacy from "./steps/Step3Privacy";
import SuccessPage from "./SuccessPage";

function QuoteDialog({
  open,
  onClose,
  showSuccess,
  activeStep,
  formData,
  errors,
  uploadedFile,
  isAnalyzing,
  analysisSuccess,
  analysisError,
  methodChosen,
  onFileDrop,
  onFileSelect,
  onDragOver,
  onRemoveFile,
  onManualEntry,
  handleChange,
  handleNext,
  handleBack,
  onReset,
}) {
  const renderStepContent = (step) => {
    const commonProps = {
      formData,
      errors,
      handleChange,
    };

    switch (step) {
      case 0:
        return (
          <Step0Service
            {...commonProps}
            uploadedFile={uploadedFile}
            isAnalyzing={isAnalyzing}
            analysisSuccess={analysisSuccess}
            analysisError={analysisError}
            methodChosen={methodChosen}
            onFileDrop={onFileDrop}
            onFileSelect={onFileSelect}
            onDragOver={onDragOver}
            onRemoveFile={onRemoveFile}
            onManualEntry={onManualEntry}
          />
        );
      case 1:
        return <Step1Profile {...commonProps} />;
      case 2:
        return <Step2Contacts {...commonProps} />;
      case 3:
        return <Step3Privacy {...commonProps} />;
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: "90vh",
        },
      }}
    >
      {!showSuccess ? (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Richiedi Preventivo
            </Typography>
            <IconButton onClick={onClose} size="small">
              <CloseRoundedIcon />
            </IconButton>
          </Box>

          <Stepper activeStep={activeStep} sx={{ px: 3, pt: 3 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          <DialogContent sx={{ px: 3, py: 4 }}>
            {renderStepContent(activeStep)}
          </DialogContent>

          <Divider />

          <Box sx={{ display: "flex", gap: 2, p: 3 }}>
            <Button
              onClick={handleBack}
              disabled={activeStep === 0}
              variant="outlined"
              size="large"
            >
              Indietro
            </Button>
            <Button
              onClick={onReset}
              variant="outlined"
              size="large"
            >
              Reset
            </Button>
            <Button
              onClick={handleNext}
              variant="contained"
              size="large"
              fullWidth
              endIcon={
                activeStep === steps.length - 1 ? null : (
                  <ArrowForwardRoundedIcon />
                )
              }
            >
              {activeStep === steps.length - 1 ? "Invia Richiesta" : "Continua"}
            </Button>
          </Box>
        </>
      ) : (
        <SuccessPage onClose={onClose} />
      )}
    </Dialog>
  );
}

export default QuoteDialog;
